import React from 'react'
import Icon from 'react-icon-base'

const FTLogo = props => (
  <Icon viewBox="0 0 1024 1024" {...props}>
    <g>
      <path d="M0 0h1024v1024H0z" />
      <path
        d="M262 534.4c0 48.4 12.8 53.6 68 56V608H110.8v-17.6c45.6-2 58.4-7.6 58.4-56V218.8c0-48.4-12.8-53.6-57.2-56v-17.6h386.4l2.8 102H482c-16.4-51.6-34-68-124.4-68h-70c-21.2 0-26 4.8-26 23.6v146.4H296c72 0 87.6-12.8 96.8-61.2h17.6v163.2h-17.6c-9.6-54.4-36.8-68-96.8-68h-34.4v151.2h.4zM936 145.2H530.8l-9.6 102h23.2c14.8-50 36.8-68 85.6-68h57.2v355.2c0 48.4-12.8 53.6-65.2 56V608h223.2v-17.6c-52.4-2-65.2-7.6-65.2-56V179.2h57.2c48.8 0 70.8 18 85.6 68H946l-10-102z"
        fill="white"
      />
    </g>
  </Icon>
)

export default FTLogo



// WEBPACK FOOTER //
// ./src/components/ft-icon.js